import { LOCAL_STORAGE_AINO_PREVENT_POPUP_KEY } from "../../constants/localStorageKeys";
import { getLocalStorage, setLocalStorage } from "../../util/localStorage";

export function checkLocalStoragePopupPrevented() {
  return getLocalStorage(LOCAL_STORAGE_AINO_PREVENT_POPUP_KEY) === "true";
}

export function setLocalStoragePopupPrevented(value: boolean) {
  return setLocalStorage(
    LOCAL_STORAGE_AINO_PREVENT_POPUP_KEY,
    value ? "true" : "false"
  );
}
